/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedResultContainer_viewer$ref = any;
export type BuySharedResultContainer_viewer = {
    readonly isFavoritesEnabled: boolean | null;
    readonly " $refType": BuySharedResultContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "BuySharedResultContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "NON_MVP_SEARCH_BROWSE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
        }
    ]
} as any);
(node as any).hash = '221219ed7165c140c77e51058abb9110';
export default node;
